import { appLink } from '@app/config/appLink'
import { useLocation, useNavigate } from 'react-router-dom'

import { FEATURE_FLAGS } from '@app/app-constants'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'
import { useFetchHomeContent } from '@app/hooks/useFetchHomeContent'
import { isAuthenticatedAtom } from '@app/state/authAtom'
import { clientNameAtom } from '@app/state/clientsAtom'
import { generateLogoUrls } from '@app/utils/generateLogoUrls'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

export const useHomeNavigation = () => {
  const { isLoading } = useFetchHomeContent()
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const clientName = useAtomValue(clientNameAtom)
  const { useMultipleFeatureFlags } = useFeatureFlags()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const logos = useMemo(() => generateLogoUrls(clientName), [clientName])

  const isFeatureFlagsEnabled = useMultipleFeatureFlags([
    FEATURE_FLAGS.DATA_SUBMODULE,
    FEATURE_FLAGS.DATA_UPLOAD,
  ])

  const activeStates = {
    isWelcomeActive: pathname === appLink.homeWelcome.path,
    isFeaturesActive: pathname.startsWith(appLink.homeFeatures.path),
    isDataActive:
      pathname === appLink.homeData.path || pathname.startsWith(`${appLink.homeData.path}/`),
    isDataUploadActive: pathname === appLink.homeDataUpload.path,
    isUseCasesActive: pathname.startsWith(appLink.homeUseCases.path),
  }

  const showData = isAuthenticated && isFeatureFlagsEnabled[FEATURE_FLAGS.DATA_SUBMODULE]
  const showDataUpload = isAuthenticated && isFeatureFlagsEnabled[FEATURE_FLAGS.DATA_UPLOAD]

  return {
    isLoading,
    navigate,
    pathname,
    logos,
    activeStates,
    showData,
    showDataUpload,
  }
}
